const HiCategoriesData = [
  {
    title: "डेवलपमेंट",
    subcategories: [
      {
        title: "वेब डेवलपमेंट",
        popularTopics: [
          "जावास्क्रिप्ट", "रीएक्ट", "HTML/CSS", "MERN", "टाइपस्क्रिप्ट", "नोड.js", "एंगुलर", "व्यू.js", "स्वेल्ट"
        ]
      },
      {
        title: "मोबाइल डेवलपमेंट",
        popularTopics: [
          "फ्लटर", "रीएक्ट नेटिव", "स्विफ्ट", "कोटलिन", "एंड्रॉइड स्टूडियो", "iOS डेवलपमेंट", "ज़ Xamarin", "आयनिक"
        ]
      },
      {
        title: "प्रोग्रामिंग भाषाएँ",
        popularTopics: [
          "पाइथन", "जावा", "C++", "जावास्क्रिप्ट", "गो", "रूबी", "रस्ट", "स्विफ्ट", "C#", "PHP"
        ]
      },
      {
        title: "गेम डेवलपमेंट",
        popularTopics: [
          "यूनिटी", "अनरील इंजन", "C#", "गेम डिजाइन", "3D मॉडलिंग", "AR/VR विकास", "ब्लेंडर", "गोडोट"
        ]
      },
      {
        title: "डेटाबेस डिज़ाइन और विकास",
        popularTopics: [
          "SQL", "मोंगोडीबी", "पोस्टग्रेसक्यूएल", "फायरबेस", "डेटाबेस आर्किटेक्चर", "NoSQL", "GraphQL", "कसंड्रा"
        ]
      },
      {
        title: "सॉफ़्टवेयर परीक्षण",
        popularTopics: [
          "सेलेनियम", "यूनिट परीक्षण", "परीक्षण स्वचालन", "API परीक्षण", "JUnit", "कुकंबर", "साइप्रस", "एपियम"
        ]
      },
      {
        title: "सॉफ्टवेयर इंजीनियरिंग",
        popularTopics: [
          "सॉफ्टवेयर डिज़ाइन पैटर्न", "माइक्रोसर्विसेज", "डेवऑप्स", "सिस्टम आर्किटेक्चर", "एजाइल", "स्क्रं", "CI/CD"
        ]
      },
      {
        title: "सॉफ्टवेयर विकास उपकरण",
        popularTopics: [
          "गिट", "डॉकर", "क्यूबर्नेट्स", "जेनकिंस", "CI/CD", "IDE", "टेराफॉर्म", "वाग्रंट", "गिटलैब"
        ]
      },
      {
        title: "नो-कोड विकास",
        popularTopics: [
          "वेबफ्लो", "बबल", "एडालो", "ज़ैपियर", "एयरटेबल", "इंटीग्रोमैट", "ग्लाइड", "थंकाबल"
        ]
      }
    ]
  },
  {
    title: "व्यवसाय",
    subcategories: [
      {
        title: "उद्यमिता",
        popularTopics: [
          "स्टार्टअप", "फंडिंग", "व्यवसाय मॉडल", "उत्पाद प्रबंधन", "लीन स्टार्टअप", "पिचिंग", "स्केलिंग"
        ]
      },
      {
        title: "बिक्री",
        popularTopics: [
          "B2B बिक्री", "सौदेबाज़ी", "लीड जनरेशन", "CRM", "सेल्स फ़नल", "कोल्ड कॉलिंग", "ईमेल मार्केटिंग"
        ]
      },
      {
        title: "नेतृत्व और प्रबंधन",
        popularTopics: [
          "टीम प्रबंधन", "नेतृत्व कौशल", "एजाइल नेतृत्व", "रणनीतिक सोच", "परियोजना प्रबंधन", "OKRs"
        ]
      },
      {
        title: "व्यापार विश्लेषण",
        popularTopics: [
          "डेटा विश्लेषण", "पावर BI", "टेबल्यू", "वित्तीय मॉडलिंग", "व्यापार बुद्धिमत्ता", "डेटा दृश्यता", "Excel"
        ]
      }
    ]
  },
  {
    title: "वित्त और लेखा",
    subcategories: [
      {
        title: "वित्तीय लेखा",
        popularTopics: [
          "बैलेंस शीट", "आय विवरण", "GAAP", "IFRS", "ऑडिटिंग", "बुककीपिंग", "कराधान", "क्विकबुक्स"
        ]
      },
      {
        title: "कॉर्पोरेट वित्त",
        popularTopics: [
          "राजधानी बजट", "कॉर्पोरेट मूल्यांकन", "जोखिम प्रबंधन", "विलय और अधिग्रहण", "निवेश बैंकिंग", "IPO"
        ]
      },
      {
        title: "व्यक्तिगत वित्त",
        popularTopics: [
          "बजट बनाना", "बचत", "निवेश", "रिटायरमेंट योजना", "वित्तीय स्वतंत्रता", "रियल एस्टेट", "स्टॉक्स"
        ]
      }
    ]
  },
  {
    title: "IT और सॉफ़्टवेयर",
    subcategories: [
      {
        title: "क्लाउड कंप्यूटिंग",
        popularTopics: [
          "AWS", "एज़्योर", "गूगल क्लाउड", "क्यूबर्नेट्स", "सर्वरलेस आर्किटेक्चर", "क्लाउड सुरक्षा", "डेवऑप्स", "ओपनशिफ्ट"
        ]
      },
      {
        title: "साइबर सुरक्षा",
        popularTopics: [
          "नैतिक हैकिंग", "पेनिट्रेशन परीक्षण", "नेटवर्क सुरक्षा", "क्रिप्टोग्राफी", "साइबर खतरें", "फायरवॉल", "SOC"
        ]
      },
      {
        title: "नेटवर्किंग",
        popularTopics: [
          "CCNA", "नेटवर्क प्रोटोकॉल", "सिस्को", "SDN", "नेटवर्क सुरक्षा", "राउटिंग", "VPN", "स्विचिंग"
        ]
      }
    ]
  },
  {
    title: "डिज़ाइन",
    subcategories: [
      {
        title: "ग्राफिक डिज़ाइन",
        popularTopics: [
          "फोटोशॉप", "इलस्ट्रेटर", "इनडिज़ाइन", "कैनवा", "टाइपोग्राफी", "रंग सिद्धांत", "लोगो डिज़ाइन", "ब्रांडिंग"
        ]
      },
      {
        title: "UI/UX डिज़ाइन",
        popularTopics: [
          "फिग्मा", "एडोब XD", "स्केच", "वायरफ्रेमिंग", "प्रोटोटाइपिंग", "उपयोगकर्ता अनुसंधान", "उपयोगिता परीक्षण"
        ]
      },
      {
        title: "3D और एनिमेशन",
        popularTopics: [
          "ब्लेंडर", "माया", "3ds मैक्स", "सिनेमाअन 4D", "आफ्टर इफेक्ट्स", "मोशन ग्राफिक्स", "कैरेक्टर एनिमेशन"
        ]
      }
    ]
  },
  {
    title: "मार्केटिंग",
    subcategories: [
      {
        title: "डिजिटल मार्केटिंग",
        popularTopics: [
          "SEO", "गूगल ऐड्स", "फेसबुक ऐड्स", "सामग्री मार्केटिंग", "सोशल मीडिया मार्केटिंग", "PPC", "इन्फ्लुएंसर मार्केटिंग"
        ]
      },
      {
        title: "एफिलिएट मार्केटिंग",
        popularTopics: [
          "एफिलिएट नेटवर्क", "कमीशन ट्रैकिंग", "उत्पाद समीक्षाएँ", "एफिलिएट के लिए SEO", "ईमेल अभियान"
        ]
      },
      {
        title: "ब्रांडिंग",
        popularTopics: [
          "ब्रांड रणनीति", "ब्रांड पहचान", "ब्रांड आवाज", "ग्राहक संलग्नता", "पुनः ब्रांडिंग", "पीआर", "कहानी कहन"
        ]
      }
    ]
  }
];

export default HiCategoriesData;
